import { Box, Grid, Typography } from "@mui/material";
import { DashboardFiltersDto, MetricType } from "../../../types/dashboard";
import { DashboardSummary } from "../Components/DashboardSummary";
import { MMsByMonth } from "../Components/MMsByMonth";
import { BillingVsRevenue } from "../Components/BillingVsRevenue";
import { MetricsByCell } from "../Components/MetricsByCell";
import { MetricsByCollaborator } from "../Components/MetricsByCollaborator";
import { MetricsByClient } from "../Components/MetricsByClient";
import { EventsList } from "../Components/EventsList";

interface ManagerDashboardProps {
  filters: DashboardFiltersDto;
}

export const ManagerDashboard = ({ filters }: ManagerDashboardProps) => {
  return (
    <Box sx={{ flex: 1, borderLeft: "1px solid #E5E7EB" }} p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DashboardSummary />
        </Grid>

        <Grid item xs={12} md={12}>
          <MMsByMonth />
        </Grid>

        {/* <Grid item xs={12} md={4}>
          <BillingVsRevenue />
        </Grid> */}

        <Grid item xs={12} md={4} gap={2}>
          <Grid item xs={12} mb={2}>
            <MetricsByCell
              metricType={MetricType.BILLING}
              title="Faturamento previsto por célula"
              color="#5b45d4"
            />
          </Grid>

          <Grid item xs={12}>
            <MetricsByClient
              metricType={MetricType.BILLING}
              title="Faturamento previsto por cliente"
              color="#5b45d4"
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid item xs={12} mb={2}>
            <MetricsByCell
              metricType={MetricType.REVENUE}
              title="Receita prevista por célula"
              color="#1e9e6a"
            />
          </Grid>

          <Grid item xs={12}>
            <MetricsByClient
              metricType={MetricType.REVENUE}
              title="Receita prevista por cliente"
              color="#1e9e6a"
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={4} sx={{ columnSpan: 4 }}>
          <MetricsByCollaborator dashboardType="Gerente" />
        </Grid>

        <Grid item xs={12}>
          <EventsList />
        </Grid>
      </Grid>
    </Box>
  );
}; 